var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMyEyeExam = function SvgMyEyeExam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#my-eye-exam_svg__r2bpeazv4a)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.333 0H1.667a.833.833 0 00-.834.833v18.334c0 .46.373.833.834.833h16.666c.46 0 .834-.373.834-.833V.833A.833.833 0 0018.333 0zm0 19.167H1.667V.833h16.666v18.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.333 16.667h.834v-2.5h1.666v2.5h.834v-3.334H8.333v3.334zm-.833-.834H5v-1.666h2.5v-.834H4.167v3.334H7.5v-.834zm5-1.666H15v1.666h-2.5v.834h3.333v-3.334H12.5v.834zm.417-3.334V8.75h-.834V10H8.75V7.5h2.083v-.833H8.75v-2.5h3.333v1.25h.834V3.333h-6.25v.834h1.25V10h-1.25v.833h6.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "my-eye-exam_svg__r2bpeazv4a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMyEyeExam;